import { useSearchParams } from "react-router-dom";
import TabDashboardRFS from "./TabDashboardRFS";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import TabDashboardTableau from "./TabDashboardTableau";
import TabDashboardInfo from "./TabDashboardInfo";

export default function DashboardNROTabs() {
  const [searchParams, setSearchParams] = useSearchParams(
    new URLSearchParams("tab=rfs"),
  );

  const tabs = [
    {
      value: "rfs",
      label: "Dashboard RFS",
      panel: <TabDashboardRFS />,
    },
    {
      value: "tableau",
      label: "Dashboard Tableau",
      panel: <TabDashboardTableau />,
    },
    {
      value: "info",
      label: "Info",
      panel: <TabDashboardInfo />,
    },
  ];

  function handleTabChange(value: string) {
    setSearchParams({ tab: value });
  }

  return (
    <Tabs
      value={searchParams.get("tab") ?? "rfs"}
      onValueChange={handleTabChange}
      className="w-full"
    >
      <TabsList className="sticky top-12 flex w-fit justify-start bg-slate-100 py-4">
        {tabs.map((tab) => (
          <TabsTrigger key={tab.value} value={tab.value}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className="p-2">
          {tab.panel}
        </TabsContent>
      ))}
    </Tabs>
  );
}
